import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3795a670")

_pushScopeId("data-v-3795a670")
const _hoisted_1 = { class: "kn-fab-button-container" }
const _hoisted_2 = { class: "kn-fab-button kn-no-select" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", { class: _ctx.icon }, null, 2)
    ])
  ]))
})